import { IField } from "../../../types/Form/IForm";

export default function numberFieldValidator(field: IField) {
    if (!field.VALUES || field.VALUES.length === 0 || !field.VALUES[0] || field.VALUES[0] === '')
        return `*required`
}